module.exports = __webpack_public_path__ + "img/img12m.524c409b.svg";